import { useAuth } from '../../context/AuthContext'
import { ROLES, ROLE_BADGE, useRoleText } from './roles'

// Ticks for an account's roles, each with its description.
// RRHH can't hand out the admin role, so it isn't offered to them.
export default function RolesChecklist({ value, onChange }) {
  const { roleLabel, roleDesc } = useRoleText()
  const sinAdmin = !useAuth().hasRole('admin')
  const toggle = (role) => onChange(value.includes(role) ? value.filter(r => r !== role) : [...value, role])
  return (
    <div className="space-y-1.5">
      {ROLES.filter(r => !(sinAdmin && r.value === 'admin')).map(r => {
        const checked = value.includes(r.value)
        return (
          <label
            key={r.value}
            className={`flex items-start gap-2.5 px-3 py-2 rounded-lg border cursor-pointer transition-colors ${
              checked ? 'border-gray-300 bg-gray-50' : 'border-gray-200 hover:bg-gray-50'
            }`}
          >
            <input type="checkbox" checked={checked} onChange={() => toggle(r.value)} className="mt-0.5 accent-gray-900" />
            <div className="min-w-0 flex-1">
              <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${ROLE_BADGE[r.value]}`}>
                {roleLabel(r.value)}
              </span>
              <p className="text-[11px] text-gray-500 mt-1">{roleDesc(r.value)}</p>
            </div>
          </label>
        )
      })}
    </div>
  )
}
